import React, { useEffect, useState, useContext } from "react";
import contentService from "../../services/api/content-service";
import UserContext from "../../UserContext";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  Alert,
  Spinner,
  Container,
  Row,
  Col,
} from "reactstrap";

const FEED_TYPE_OPTIONS = [
  { value: "", label: "Auto Detect" },
  { value: "1", label: "XML (RSS / Atom)" },
  { value: "2", label: "JSON" },
];

const TRANSFORM_LABELS = {
  none: "None",
  strip_html: "Strip HTML",
  slugify: "Slugify",
  split_comma: "List / Comma Split",
  date: "Date",
};

// scoped styles, theme defaults (uppercase table heads, tall rounded inputs) are too heavy for this screen
const CSS = `
.cf-page .cf-label { font-size: 12px; font-weight: 600; color: #66615b; margin-bottom: 6px; display: block; text-align: left; }
.cf-input, .cf-select {
  width: 100%; height: 36px; padding: 6px 10px; font-size: 14px; color: #333;
  border: 1px solid #d9dce1; border-radius: 6px; background: #fff; outline: none; box-shadow: none;
}
.cf-input:focus, .cf-select:focus { border-color: #51bcda; }
.cf-input.sm, .cf-select.sm { height: 32px; font-size: 13px; padding: 4px 8px; }
.cf-btn { border-radius: 6px !important; margin: 0 !important; text-transform: none !important; font-weight: 600 !important;
  white-space: nowrap; font-size: 13px !important; padding: 0 16px !important; height: 34px; line-height: 32px !important; }
.cf-btn-lg { height: 40px; line-height: 38px !important; min-width: 130px; }
.cf-actions { display: flex; gap: 8px; justify-content: flex-end; flex-wrap: wrap; }
.cf-link { font-size: 12px; color: #51bcda; cursor: pointer; }
.cf-muted { font-size: 12px; color: #888; }
.cf-status { background: #f7f8fa; border: 1px solid #e6e8eb; border-radius: 8px; padding: 12px 16px; margin-bottom: 20px; text-align: left; }
.cf-pill { display: inline-block; font-size: 11px; font-weight: 700; padding: 2px 8px; border-radius: 10px; margin-right: 6px; }
.cf-pill.green { background: #e3f6ea; color: #1e8e3e; }
.cf-pill.grey { background: #eceef1; color: #666; }
.cf-pill.red { background: #fde8e8; color: #c62828; }
.cf-pill.amber { background: #fff4de; color: #b26a00; }
.cf-pill.blue { background: #e3f2fd; color: #1565c0; }

.cf-modal .modal-content { border-radius: 10px; overflow: hidden; }
.cf-modal-head { display: flex; justify-content: space-between; align-items: center; padding: 16px 24px; border-bottom: 1px solid #eceef1; }
.cf-modal-title { font-size: 18px; font-weight: 600; color: #333; margin: 0; }
.cf-close { font-size: 24px; line-height: 1; color: #999; cursor: pointer; background: none; border: none; }
.cf-modal-foot { display: flex; justify-content: space-between; align-items: center; padding: 14px 24px; border-top: 1px solid #eceef1; background: #fafbfc; }
.cf-panel { border: 1px solid #e6e8eb; border-radius: 8px; background: #fff; display: flex; flex-direction: column; height: 62vh; }
.cf-panel-head { padding: 12px 14px; border-bottom: 1px solid #eceef1; display: flex; justify-content: space-between; align-items: center; }
.cf-panel-title { font-size: 14px; font-weight: 700; color: #333; }
.cf-panel-body { overflow-y: auto; flex: 1; }
.cf-count { font-size: 11px; font-weight: 600; color: #666; background: #eceef1; border-radius: 10px; padding: 2px 8px; }

.cf-feed-field { padding: 9px 14px; border-bottom: 1px solid #f1f2f4; text-align: left; }
.cf-feed-field:last-child { border-bottom: none; }
.cf-feed-path { font-family: monospace; font-size: 12px; font-weight: 700; color: #2c3e50; word-break: break-all; }
.cf-feed-sample { font-size: 12px; color: #777; margin-top: 2px; word-break: break-word;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }

.cf-grid { display: grid; grid-template-columns: 1.1fr 1.5fr 0.9fr 0.9fr; gap: 10px; align-items: start; }
.cf-grid-head { padding: 8px 14px; font-size: 11px; font-weight: 700; color: #999; text-transform: uppercase; letter-spacing: .4px;
  border-bottom: 1px solid #eceef1; position: sticky; top: 0; background: #fff; z-index: 1; }
.cf-row { padding: 10px 14px; border-bottom: 1px solid #f1f2f4; text-align: left; }
.cf-row.missing { background: #fff7f7; }
.cf-field-name { font-size: 13px; font-weight: 600; color: #333; padding-top: 6px; }
.cf-req { color: #e53935; }
.cf-hint { font-size: 11px; color: #a0a0a0; margin-top: 2px; line-height: 1.3; }
.cf-sample { font-size: 11px; color: #8a8a8a; margin-top: 4px; word-break: break-word;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }

.cf-preview-item { display: flex; gap: 16px; padding: 16px; border-bottom: 1px solid #f1f2f4; text-align: left; }
.cf-preview-img { width: 180px; min-width: 180px; height: 110px; object-fit: cover; border-radius: 6px; background: #f1f2f4; }
.cf-preview-title { font-size: 15px; font-weight: 600; color: #333; margin-bottom: 4px; }
.cf-preview-meta { font-size: 12px; color: #777; line-height: 1.6; word-break: break-all; }
.cf-tag { display: inline-block; font-size: 11px; background: #eceef1; color: #555; border-radius: 4px; padding: 1px 6px; margin: 4px 4px 0 0; }
`;

const CategoryFeed = (props) => {
  const context = useContext(UserContext);
  const projectId = props.projectId;
  const category = props.category;

  const [importer, setImporter] = useState(null);
  const [feedUrl, setFeedUrl] = useState("");
  const [feedType, setFeedType] = useState("");
  const [itemPath, setItemPath] = useState("");
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [itemCount, setItemCount] = useState(0);
  const [feedFields, setFeedFields] = useState([]);
  const [fieldSearch, setFieldSearch] = useState("");
  const [sortdFields, setSortdFields] = useState([]);
  const [transforms, setTransforms] = useState(Object.keys(TRANSFORM_LABELS));
  const [mapping, setMapping] = useState({});
  const [status, setStatus] = useState(true);
  const [testResults, setTestResults] = useState(false);
  const [showMapping, setShowMapping] = useState(false);
  const [modalView, setModalView] = useState("mapping");
  const [loading, setLoading] = useState({ page: true, fetch: false, test: false, save: false, run: false, status: false, refresh: false });
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [modalAlert, setModalAlert] = useState({ show: false, message: "", type: "" });

  const showAlert = (type, message, inModal = false) => {
    const setter = inModal ? setModalAlert : setAlert;
    setter({ show: true, type, message });
    setTimeout(() => {
      setter({ show: false, type: "", message: "" });
    }, 5000);
  };

  const setLoadingState = (key, value) => {
    setLoading((prev) => ({ ...prev, [key]: value }));
  };

  const handleResponse = (response, inModal = false) => {
    if (!response.status && response.error && response.error.errorCode === 403) {
      context.setIsAuthorized(context);
      return false;
    }
    if (!response.status) {
      showAlert("danger", (response.error && response.error.message) || "Something went wrong", inModal);
      return false;
    }
    return true;
  };

  const mappingFromList = (list = []) => {
    const mappingObj = {};
    list.forEach((rule) => {
      mappingObj[rule.sortd_field] = {
        source_path: rule.source_path || "",
        transform: rule.transform || "none",
        default_value: rule.default_value || "",
      };
    });
    return mappingObj;
  };

  const mappingToList = () => {
    return sortdFields.map((field) => ({
      sortd_field: field.key,
      source_path: (mapping[field.key] && mapping[field.key].source_path) || "",
      transform: (mapping[field.key] && mapping[field.key].transform) || field.transform || "none",
      default_value: (mapping[field.key] && mapping[field.key].default_value) || "",
    }));
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await contentService.getCategoryFeed(projectId, category._id);
        if (handleResponse(response) && response.data) {
          const savedImporter = response.data;
          setImporter(savedImporter);
          setFeedUrl(savedImporter.feed_url);
          setFeedType(String(savedImporter.feed_type || ""));
          setItemPath(savedImporter.item_path || "");
          setStatus(savedImporter.status);
          setMapping(mappingFromList(savedImporter.feed_mapping));
          // saved snapshot of feed fields, so the mapping popup opens without fetching the feed again
          if (savedImporter.feed_fields && savedImporter.feed_fields.length) {
            setFeedFields(savedImporter.feed_fields);
            setItemCount(savedImporter.item_count || 0);
            setSortdFields(savedImporter.sortd_fields || []);
            setTransforms(savedImporter.transforms || Object.keys(TRANSFORM_LABELS));
          }
        }
      } catch (err) {
        console.log(err);
      }
      setLoadingState("page", false);
    })();
  }, []);

  // fetches the feed and opens the mapping popup
  const fetchFeed = async () => {
    if (!feedUrl || !feedUrl.trim()) {
      showAlert("danger", "Please enter the feed url");
      return;
    }
    setLoadingState("fetch", true);
    setTestResults(false);
    try {
      const response = await contentService.previewCategoryFeed({
        feedUrl: feedUrl.trim(),
        feedType,
        itemPath,
      });
      if (handleResponse(response)) {
        const preview = response.data;
        setFeedType(String(preview.feed_type));
        setItemPath(preview.item_path || "");
        setItemCount(preview.item_count);
        setFeedFields(preview.fields || []);
        setSortdFields(preview.sortd_fields || []);
        setTransforms(preview.transforms || Object.keys(TRANSFORM_LABELS));

        // saved mapping (same url) wins over suggestions
        const suggested = mappingFromList(preview.suggested_mapping);
        const useSaved = importer && importer.feed_url === feedUrl.trim() && Object.keys(mapping).length;
        if (useSaved) {
          const merged = {};
          (preview.sortd_fields || []).forEach((field) => {
            merged[field.key] = mapping[field.key] || {
              source_path: "",
              transform: suggested[field.key] ? suggested[field.key].transform : "none",
              default_value: "",
            };
          });
          setMapping(merged);
        } else {
          setMapping(suggested);
        }
        setFieldSearch("");
        setModalView("mapping");
        setShowMapping(true);
      }
    } catch (err) {
      console.log(err);
      showAlert("danger", "Unable to fetch the feed");
    }
    setLoadingState("fetch", false);
  };

  // saved feed with the same url opens from the saved fields, otherwise the feed is fetched
  const canOpenSaved = !!(importer && feedUrl.trim() === importer.feed_url && feedFields.length && sortdFields.length);

  const openMapping = () => {
    if (canOpenSaved) {
      setTestResults(false);
      setFieldSearch("");
      setModalView("mapping");
      setShowMapping(true);
      return;
    }
    fetchFeed();
  };

  const handleMappingChange = (fieldKey, key, value) => {
    setMapping((prev) => ({
      ...prev,
      [fieldKey]: {
        ...(prev[fieldKey] || { source_path: "", transform: "none", default_value: "" }),
        [key]: value,
      },
    }));
    setTestResults(false);
  };

  const getSample = (path) => {
    const field = feedFields.find((f) => f.path === path);
    return field ? field.sample : "";
  };

  const isMapped = (fieldKey) => {
    const rule = mapping[fieldKey];
    return !!(rule && (rule.source_path || rule.default_value));
  };

  const mappedCount = sortdFields.filter((field) => isMapped(field.key)).length;

  const validateRequired = () => {
    const missing = sortdFields.filter((field) => field.required && !isMapped(field.key));
    if (missing.length) {
      setModalView("mapping");
      showAlert("danger", "Please map required fields: " + missing.map((f) => f.label).join(", "), true);
      return false;
    }
    return true;
  };

  const testMapping = async () => {
    if (!validateRequired()) {
      return;
    }
    setLoadingState("test", true);
    try {
      const response = await contentService.testCategoryFeedMapping({
        projectId,
        categoryId: category._id,
        feedUrl: feedUrl.trim(),
        feedType,
        itemPath,
        mapping: mappingToList(),
      });
      if (handleResponse(response, true)) {
        setTestResults(response.data || []);
        setModalView("preview");
      }
    } catch (err) {
      console.log(err);
      showAlert("danger", "Unable to test the mapping", true);
    }
    setLoadingState("test", false);
  };

  const saveFeed = async () => {
    if (!validateRequired()) {
      return;
    }
    setLoadingState("save", true);
    try {
      const response = await contentService.saveCategoryFeed({
        projectId,
        categoryId: category._id,
        feedUrl: feedUrl.trim(),
        feedType,
        itemPath,
        mapping: mappingToList(),
        feedFields,
        itemCount,
        status,
      });
      if (handleResponse(response, true)) {
        setImporter(response.data);
        setShowMapping(false);
        showAlert("success", "Feed saved successfully");
      }
    } catch (err) {
      console.log(err);
      showAlert("danger", "Unable to save the feed", true);
    }
    setLoadingState("save", false);
  };

  const toggleStatus = async () => {
    if (!importer) {
      return;
    }
    setLoadingState("status", true);
    try {
      const response = await contentService.updateCategoryFeedStatus(importer.id, !importer.status);
      if (handleResponse(response)) {
        setImporter(response.data);
        setStatus(response.data.status);
        showAlert("success", response.data.status ? "Feed activated" : "Feed deactivated");
      }
    } catch (err) {
      console.log(err);
    }
    setLoadingState("status", false);
  };

  const runNow = async () => {
    if (!importer) {
      return;
    }
    setLoadingState("run", true);
    try {
      const response = await contentService.runCategoryFeed(importer.id);
      if (handleResponse(response)) {
        showAlert("success", "Feed sync started. Click Refresh in a minute to see the result.");
      }
    } catch (err) {
      console.log(err);
    }
    setLoadingState("run", false);
  };

  const refreshImporter = async () => {
    setLoadingState("refresh", true);
    try {
      const response = await contentService.getCategoryFeed(projectId, category._id);
      if (handleResponse(response) && response.data) {
        setImporter(response.data);
      }
    } catch (err) {
      console.log(err);
    }
    setLoadingState("refresh", false);
  };

  const statusPill = (lastStatus) => {
    const colors = { success: "green", partial: "amber", failed: "red", running: "blue" };
    return <span className={"cf-pill " + (colors[lastStatus] || "grey")}>Last run: {lastStatus}</span>;
  };

  const renderImporterStatus = () => {
    if (!importer) {
      return "";
    }
    return (
      <div className="cf-status">
        <Row className="align-items-center">
          <Col md="7">
            <div style={{ marginBottom: "6px" }}>
              <span className={"cf-pill " + (importer.status ? "green" : "grey")}>{importer.status ? "Active" : "Inactive"}</span>
              {importer.last_status ? statusPill(importer.last_status) : ""}
            </div>
            <div className="cf-muted">
              {importer.last_run_at ? (
                <>
                  Last run on {new Date(importer.last_run_at).toLocaleString("en-IN")} &nbsp;·&nbsp;
                  <b>{importer.last_synced_count || 0}</b> synced &nbsp;·&nbsp;
                  <b>{importer.last_skipped_count || 0}</b> unchanged &nbsp;·&nbsp;
                  <b>{importer.last_failed_count || 0}</b> failed
                </>
              ) : (
                "This feed has not run yet"
              )}
            </div>
            {importer.last_error ? <div style={{ fontSize: "12px", color: "#c62828", marginTop: "4px", wordBreak: "break-word" }}>{importer.last_error}</div> : ""}
          </Col>
          <Col md="5">
            <div className="cf-actions">
              <Button color="default" outline className="cf-btn" onClick={refreshImporter} disabled={loading.refresh}>
                {loading.refresh ? "Refreshing..." : "Refresh"}
              </Button>
              <Button color={importer.status ? "danger" : "success"} outline className="cf-btn" onClick={toggleStatus} disabled={loading.status}>
                {importer.status ? "Deactivate" : "Activate"}
              </Button>
              <Button color="info" className="cf-btn" onClick={runNow} disabled={loading.run || !importer.status}>
                {loading.run ? "Starting..." : "Run Now"}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const renderFeedFields = () => {
    const search = fieldSearch.trim().toLowerCase();
    const filteredFields = search
      ? feedFields.filter((field) => field.path.toLowerCase().includes(search) || (field.sample || "").toLowerCase().includes(search))
      : feedFields;
    return (
      <div className="cf-panel">
        <div className="cf-panel-head">
          <span className="cf-panel-title">Feed Fields</span>
          <span className="cf-count">{feedFields.length}</span>
        </div>
        <div style={{ padding: "10px 14px", borderBottom: "1px solid #eceef1" }}>
          <input className="cf-input sm" value={fieldSearch} placeholder="Search fields" onChange={(e) => setFieldSearch(e.target.value)} />
        </div>
        <div className="cf-panel-body">
          {filteredFields.map((field) => (
            <div className="cf-feed-field" key={field.path}>
              <div className="cf-feed-path">
                {field.path} {field.is_list ? <span className="cf-pill blue">list</span> : ""}
              </div>
              {field.sample ? <div className="cf-feed-sample">{field.sample}</div> : ""}
            </div>
          ))}
          {!filteredFields.length ? <div className="cf-muted text-center" style={{ padding: "20px" }}>No fields found</div> : ""}
        </div>
      </div>
    );
  };

  const renderSortdFields = () => (
    <div className="cf-panel">
      <div className="cf-panel-head">
        <span className="cf-panel-title">Sortd Article Fields</span>
        <span className="cf-count">
          {mappedCount}/{sortdFields.length} mapped
        </span>
      </div>
      <div className="cf-panel-body">
        <div className="cf-grid cf-grid-head">
          <div>Sortd Field</div>
          <div>Feed Field</div>
          <div>Transform</div>
          <div>Fallback</div>
        </div>
        {sortdFields.map((field) => {
          const rule = mapping[field.key] || { source_path: "", transform: field.transform || "none", default_value: "" };
          const sample = rule.source_path ? getSample(rule.source_path) : "";
          const missing = field.required && !isMapped(field.key);
          return (
            <div className={"cf-grid cf-row" + (missing ? " missing" : "")} key={field.key}>
              <div>
                <div className="cf-field-name">
                  {field.label}
                  {field.required ? <span className="cf-req"> *</span> : ""}
                </div>
                {field.hint ? <div className="cf-hint">{field.hint}</div> : ""}
              </div>
              <div>
                <select className="cf-select sm" value={rule.source_path} onChange={(e) => handleMappingChange(field.key, "source_path", e.target.value)}>
                  <option value="">-- Not mapped --</option>
                  {feedFields.map((feedField) => (
                    <option key={feedField.path} value={feedField.path}>
                      {feedField.path}
                    </option>
                  ))}
                </select>
                {sample ? <div className="cf-sample">{sample}</div> : ""}
              </div>
              <div>
                <select className="cf-select sm" value={rule.transform} onChange={(e) => handleMappingChange(field.key, "transform", e.target.value)}>
                  {transforms.map((transform) => (
                    <option key={transform} value={transform}>
                      {TRANSFORM_LABELS[transform] || transform}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <input
                  className="cf-input sm"
                  value={rule.default_value}
                  placeholder="Optional"
                  onChange={(e) => handleMappingChange(field.key, "default_value", e.target.value)}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  const renderPreview = () => (
    <div className="cf-panel">
      <div className="cf-panel-head">
        <span className="cf-panel-title">Preview — first {testResults ? testResults.length : 0} items as Sortd articles</span>
        <span className="cf-muted">Nothing is saved</span>
      </div>
      <div className="cf-panel-body">
        {testResults && testResults.length ? (
          testResults.map((result, index) => {
            const article = result.articleData || {};
            const thumb = result.mediaData && result.mediaData.image_media && result.mediaData.image_media[0];
            return (
              <div className="cf-preview-item" key={index}>
                {thumb ? <img className="cf-preview-img" src={thumb.original_url} alt="" /> : <div className="cf-preview-img" />}
                <div style={{ flex: 1 }}>
                  {result.errors && result.errors.length ? (
                    <div style={{ fontSize: "12px", color: "#c62828", marginBottom: "4px" }}>{result.errors.join(", ")}</div>
                  ) : (
                    ""
                  )}
                  <div className="cf-preview-title">{article.title}</div>
                  {article.post_excerpt ? <div style={{ fontSize: "13px", color: "#555", marginBottom: "6px" }}>{article.post_excerpt}</div> : ""}
                  <div className="cf-preview-meta">
                    <div>
                      <b>Slug:</b> {article.slug}
                    </div>
                    <div>
                      <b>URL:</b> {article.share_url}
                    </div>
                    <div>
                      <b>Published:</b> {article.article_published_on ? new Date(article.article_published_on).toLocaleString("en-IN") : ""}
                      {article.author ? <> &nbsp;·&nbsp; <b>Author:</b> {article.author}</> : ""}
                    </div>
                  </div>
                  {article.tags && article.tags.length ? (
                    <div>
                      {article.tags.map((tag) => (
                        <span className="cf-tag" key={tag}>
                          {tag}
                        </span>
                      ))}
                    </div>
                  ) : (
                    ""
                  )}
                  <details style={{ fontSize: "12px", marginTop: "8px" }}>
                    <summary style={{ cursor: "pointer", color: "#51bcda" }}>Full payload</summary>
                    <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", maxHeight: "240px", overflowY: "auto", background: "#f7f8fa", padding: "8px", borderRadius: "6px" }}>
                      {JSON.stringify(result, null, 2)}
                    </pre>
                  </details>
                </div>
              </div>
            );
          })
        ) : (
          <div className="cf-muted text-center" style={{ padding: "30px" }}>
            No items found in the feed
          </div>
        )}
      </div>
    </div>
  );

  const renderMappingModal = () => (
    <Modal isOpen={showMapping} toggle={() => setShowMapping(false)} className="cf-modal cf-page" style={{ maxWidth: "1300px", width: "95%" }} backdrop="static">
      <div className="cf-modal-head">
        <div style={{ textAlign: "left" }}>
          <h5 className="cf-modal-title">{modalView === "preview" ? "Preview Mapping" : "Map Feed Fields"}</h5>
          <div className="cf-muted">
            {category.name} &nbsp;·&nbsp; {itemCount} items found{itemPath ? <> at <code>{itemPath}</code></> : ""}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Button color="info" outline className="cf-btn" onClick={fetchFeed} disabled={loading.fetch}>
            {loading.fetch ? "Refreshing..." : "Refresh Fields"}
          </Button>
          <button className="cf-close" onClick={() => setShowMapping(false)}>
            &times;
          </button>
        </div>
      </div>
      <ModalBody style={{ padding: "16px 24px", background: "#f7f8fa" }}>
        {modalAlert.show ? <Alert color={modalAlert.type}>{modalAlert.message}</Alert> : ""}
        {modalView === "preview" ? (
          renderPreview()
        ) : (
          <Row>
            <Col lg="4" style={{ marginBottom: "12px" }}>
              {renderFeedFields()}
            </Col>
            <Col lg="8">{renderSortdFields()}</Col>
          </Row>
        )}
      </ModalBody>
      <div className="cf-modal-foot">
        <label style={{ display: "flex", alignItems: "center", gap: "8px", margin: 0, fontSize: "13px", color: "#555", cursor: "pointer" }}>
          <input type="checkbox" checked={status} onChange={(e) => setStatus(e.target.checked)} />
          Active (sync this feed automatically)
        </label>
        <div>
          <Button color="default" outline className="cf-btn" onClick={() => setShowMapping(false)}>
            Cancel
          </Button>{" "}
          {modalView === "preview" ? (
            <Button color="info" outline className="cf-btn" onClick={() => setModalView("mapping")}>
              Back to Mapping
            </Button>
          ) : (
            <Button color="info" outline className="cf-btn" onClick={testMapping} disabled={loading.test}>
              {loading.test ? "Testing..." : "Test Mapping"}
            </Button>
          )}{" "}
          <Button color="primary" className="cf-btn" onClick={saveFeed} disabled={loading.save}>
            {loading.save ? "Saving..." : "Save Feed"}
          </Button>
        </div>
      </div>
    </Modal>
  );

  return (
    <div className="content cf-page">
      <style>{CSS}</style>
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" md="12">
            <Card className="card-signup">
              <CardHeader>
                <div className="d-flex justify-content-between align-items-center">
                  <div style={{ textAlign: "left" }}>
                    <CardTitle tag="h4" style={{ margin: 0 }}>
                      Category Feed
                    </CardTitle>
                    <div className="cf-muted">{category.name}</div>
                  </div>
                  <Button color="default" outline className="cf-btn" onClick={() => props.setFeedCategory(false)}>
                    &larr; Back to Categories
                  </Button>
                </div>
              </CardHeader>
              <CardBody>
                {loading.page ? (
                  <div className="text-center" style={{ padding: "40px 0" }}>
                    <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <>
                    {renderImporterStatus()}
                    {alert.show ? <Alert color={alert.type}>{alert.message}</Alert> : ""}

                    <label className="cf-label">Feed URL</label>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <input
                        className="cf-input"
                        style={{ height: "40px" }}
                        value={feedUrl}
                        placeholder="Paste RSS / Atom / JSON feed url e.g. https://www.example.com/feed.rss"
                        onChange={(e) => setFeedUrl(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            openMapping();
                          }
                        }}
                      />
                      <Button color="info" className="cf-btn cf-btn-lg" onClick={openMapping} disabled={loading.fetch}>
                        {loading.fetch ? "Fetching..." : canOpenSaved ? "Edit Mapping" : "Fetch Feed"}
                      </Button>
                    </div>
                    <div className="d-flex justify-content-between" style={{ marginTop: "8px" }}>
                      <span className="cf-muted">Fetch the feed to map its fields with Sortd article fields.</span>
                      <span className="cf-link" onClick={() => setShowAdvanced(!showAdvanced)}>
                        {showAdvanced ? "Hide advanced options" : "Advanced options"}
                      </span>
                    </div>

                    {showAdvanced ? (
                      <Row style={{ marginTop: "14px" }}>
                        <Col md="4">
                          <label className="cf-label">Feed Type</label>
                          <select className="cf-select" value={feedType} onChange={(e) => setFeedType(e.target.value)}>
                            {FEED_TYPE_OPTIONS.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </Col>
                        <Col md="8">
                          <label className="cf-label">Items Path (where the list of articles is inside the feed)</label>
                          <input className="cf-input" value={itemPath} placeholder="Auto detect e.g. rss.channel.item" onChange={(e) => setItemPath(e.target.value)} />
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {renderMappingModal()}
    </div>
  );
};

export default CategoryFeed;
